<template>
  <div>
    <v-card flat>
      <v-card-title primary-title class="mx-5">
        <h2>ผู้ใช้งาน</h2>
      </v-card-title>
      <v-card-text>
        <!-- Search && Filter -->
        <v-row class="mx-2">
          <v-col cols="12" sm="6" md="8" class="py-0">
            <v-text-field label="ค้นหา" clearable v-model="search" dense outlined></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="4" class="py-0">
            <v-select
              :items="permission_list"
              v-model="filter_permission"
              item-text="permissionName"
              item-value="permissionId"
              label="สิทธิ์การใช้งาน"
              clearable
              dense
              outlined
            ></v-select>
          </v-col>
        </v-row>
        <v-divider class="mx-5"></v-divider>
        <!-- Add new Data -->
        <v-toolbar flat>
          <h4>{{ summary_title }} {{ summary_value }} รายการ</h4>
          <v-spacer></v-spacer>
          <v-btn class="bg_btn_gradient" dark @click="openUserDialog('create', null)">
            <v-icon left>mdi-plus-circle</v-icon>
            <span class="text_body_6">เพิ่มผู้ใช้งาน</span>
          </v-btn>
        </v-toolbar>
        <v-container fluid>
          <v-data-table
            id="table-text"
            :headers="user_headers"
            :items="filterUserDataList"
            :loading="dataTableLoading"
            :search="search"
          >
            <template v-slot:item.no="{ item }">{{ userDataList.indexOf(item) + 1 }}.</template>

            <template v-slot:item.roleName="{ item }">
              <v-menu transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <div class="text-center">
                    <v-btn
                      outlined
                      color="secondary"
                      block
                      v-on="on"
                    >{{ item.permissionName ? item.permissionName : "-" }}</v-btn>
                  </div>
                </template>
                <v-list>
                  <!-- all status list -->
                  <v-list-item v-for="(permission, index) in permission_list" :key="index">
                    <v-spacer></v-spacer>
                    <v-btn
                      class="px-2"
                      outlined
                      block
                      color="secondary"
                      :disabled="item.permissionId == permission.permissionId"
                      @click="
                        changeUserPermission(item, permission.permissionId)
                      "
                    >{{ permission.permissionName }}</v-btn>
                    <v-spacer></v-spacer>
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-btn icon small @click="openUserDialog('edit', item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
              <v-btn icon small color="error" @click="deleteUser(item)">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-container>
      </v-card-text>
    </v-card>
    <!-- action dialog -->
    <v-dialog
      v-model="user_dialog"
      scrollable
      persistent
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title style="background-color: #0c57d2; color: #ffffff">
          <h3>{{ mode == "create" ? "เพิ่มผู้ใช้งานใหม่" : "แก้ไขผู้ใช้งาน" }}</h3>
        </v-card-title>
        <v-card-text>
          <v-form ref="user_form">
            <v-toolbar flat>
              <h4 class="mr-2">ข้อมูลบุคคล</h4>
              <v-divider></v-divider>
            </v-toolbar>
            <v-text-field
              v-model="firstName"
              name="firstName"
              label="ชื่อ"
              id="firstName"
              outlined
              dense
              :rules="rule_firstname"
            ></v-text-field>
            <v-text-field
              v-model="lastName"
              name="lastName"
              label="นามสกุล"
              id="lastName"
              :rules="rule_lastname"
              outlined
              dense
            ></v-text-field>
            <v-text-field
              v-model="email"
              name="email"
              label="Email"
              id="email"
              :rules="rule_email"
              outlined
              dense
            ></v-text-field>
            <v-toolbar flat>
              <h4 class="mr-2">บัญชีผู้ใช้</h4>
              <v-divider></v-divider>
            </v-toolbar>
            <v-text-field
              v-model="username"
              name="Username"
              label="ชื่อผู้ใช้"
              id="Username"
              :rules="rule_username"
              outlined
              dense
            ></v-text-field>
            <v-checkbox
              class="ma-0 pa-0"
              label="รีเซ็ตรหัสผ่าน"
              v-model="resetPassword"
              v-if="mode == 'edit'"
            ></v-checkbox>
            <span v-if="mode == 'edit' ? resetPassword : true">
              <v-text-field
                v-model="password"
                name="Password"
                label="รหัสผ่าน"
                id="Password"
                type="password"
                :rules="rule_password"
                outlined
                dense
              ></v-text-field>
              <v-text-field
                v-model="confirm_password"
                name="Confirm Password"
                label="ยืนยันรหัสผ่าน"
                id="Confirm Password"
                type="password"
                :rules="rule_confirm_password"
                outlined
                dense
              ></v-text-field>
            </span>
            <v-toolbar flat>
              <h4 class="mr-2">สิทธิ์การใช้งาน</h4>
              <v-divider></v-divider>
            </v-toolbar>
            <v-select
              :items="permission_list"
              item-text="permissionName"
              item-value="permissionId"
              v-model="role"
              label="Role"
              :rules="rule_permission"
              outlined
              dense
            ></v-select>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mr-2" color="error" outlined @click="closeUserDialog()">ยกเลิก</v-btn>
          <v-btn color="primary" @click="saveUserData()">บันทึก</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import * as rules from "@/assets/javascript/rules.js";
export default {
  data() {
    return {
      header_token: {
        headers: {
          token: this.$session.get("token_roy"),
        },
      },
      user_headers: [
        {
          text: "ลำดับ",
          value: "no",
          sortable: false,
        },
        {
          text: "ชื่อ-นามสกุล",
          value: "fullName",
          sortable: false,
          align: "left",
          width: "35%",
        },
        {
          text: "อีเมล",
          value: "email",
          sortable: false,
          align: "left",
          width: "25%",
        },
        {
          text: "ชื่อผู้ใช้",
          value: "username",
          sortable: false,
          align: "left",
        },
        {
          text: "สิทธิ์",
          value: "roleName",
          sortable: false,
          align: "center",
        },
        {
          text: "จัดการ",
          value: "actions",
          sortable: false,
          align: "center",
        },
      ],
      userDataList: [],
      permission_list: [],
      // mode (CREATE / EDIT)
      mode: "",
      user_index: "",
      // insert variable
      firstName: "",
      lastName: "",
      email: "",
      username: "",
      password: "",
      confirm_password: "",
      role: "",
      resetPassword: false,

      // search text and value
      search: "",
      filter_permission: "",

      summary_title: "รายการทั้งหมด",
      summary_value: 0,

      // loading
      dataTableLoading: false,

      //   Add User Dialog
      user_dialog: false,
      // rules
      rule_firstname: rules.firstname,
      rule_lastname: rules.lastname,
      rule_email: rules.email,
      rule_username: rules.username,
      rule_password: rules.password,
      rule_confirm_password: [
        (v) => !!v || "กรุณายืนยันรหัสผ่าน",
        (v) => v == this.password || "รหัสผ่านไม่ถูกต้อง",
      ],
      rule_permission: rules.isEmptyDropdown,
    };
  },
  computed: {
    filterUserDataList() {
      if (this.filter_permission) {
        return this.userDataList.filter((item) => {
          return item.permissionId == this.filter_permission;
        });
      } else {
        return this.userDataList;
      }
    },
  },
  created() {
    this.getUserList();
    this.getPermissionList();
  },
  methods: {
    changeUserPermission(item, tmp_permissionId) {
      // console.log("waiting API" + item.permissionId + "=>" + permissionId);
      let data = {
        permissionId: tmp_permissionId,
      };
      this.axios
        .put(
          process.env.VUE_APP_API + "api/v1/user/permission/" + item.userId,
          data,
          this.header_token
        )
        .then((response) => {
          // console.log(response.data);
          if (response.data == "update success") {
            this.$swal.fire({
              icon: "success",
              title: "แก้ไขข้อมูลข้อมูลผู้ใช้งานสำเร็จ",
              showConfirmButton: false,
              timer: 1000,
            });
            this.getUserList();
          } else {
            this.$swal.fire("เกิดข้อผิดพลาด", "โปรดติดต่อผู้ดูแลระบบ", "error");
          }
        })
        .catch((err) => {
          // console.log("api set new permission err");
        });
    },
    getUserList() {
      this.dataTableLoading = true;
      this.userDataList = [];
      this.axios
        .get(process.env.VUE_APP_API + "api/v1/user", this.header_token)
        .then((response) => {
          // console.log(response.data);
          let data = response.data;
          data.forEach((user, index) => {
            this.userDataList.push(user);
            this.userDataList[index].fullName =
              user.firstName + " " + user.lastName;
          });
          this.summary_value = response.data.length;
          this.dataTableLoading = false;
        })
        .catch((err) => {
          // console.log("api get err");
          this.userDataList = [];
          this.dataTableLoading = false;
        });
    },
    getPermissionList() {
      this.axios
        .get(process.env.VUE_APP_API + "api/v1/permission", this.header_token)
        .then((response) => {
          if (response.data) {
            this.permission_list = response.data;
          } else {
            this.permission_list = [];
          }
        })
        .catch((err) => {
          // console.log("get permission err");
          this.permission_list = [];
        });
    },
    openUserDialog(mode, item) {
      this.user_dialog = true;
      this.mode = mode;
      this.user_index = item ? item.userId : null;
      if (this.mode == "create") {
        setTimeout(() => {
          this.firstName = "";
          this.lastName = "";
          this.email = "";
          this.username = "";
          this.password = "";
          this.confirm_password = "";
          this.role = "";
          this.$refs.user_form.resetValidation();
        }, 50);
      } else if (this.mode == "edit") {
        this.firstName = item.firstName;
        this.lastName = item.lastName;
        this.email = item.email;
        this.username = item.username;
        this.resetPassword = false;
        this.password = "";
        this.confirm_password = "";
        this.role = item.permissionId;
        setTimeout(() => {
          this.$refs.user_form.resetValidation();
        }, 50);
      }
    },
    closeUserDialog() {
      this.mode = "";
      this.user_index = "";
      this.user_dialog = false;
    },
    saveUserData() {
      // console.log(this.role);
      if (
        this.$refs.user_form.validate() &&
        this.password == this.confirm_password
      ) {
        let data = {
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName,
          password: this.password,
          permissionId: this.role,
          username: this.username,
          resetPassword: this.resetPassword ? "1" : "0",
        };
        if (this.mode == "create") {
          this.axios
            .post(
              process.env.VUE_APP_API + "api/v1/user",
              data,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);
              if (response.data == "success") {
                this.$swal.fire({
                  icon: "success",
                  title: "สร้างข้อมูลผู้ใช้งานใหม่สำเร็จ",
                  showConfirmButton: false,
                  timer: 1000,
                });

                this.getUserList();
                this.closeUserDialog();
              } else if (response.data == "email already") {
                this.$swal.fire({
                  icon: "warning",
                  title: "ช้อมูลซ้ำ",
                  text: "อีเมลนี้ถูกใช้ไปแล้ว",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.email = "";
              } else if (response.data == "username already") {
                this.$swal.fire({
                  icon: "warning",
                  title: "ช้อมูลซ้ำ",
                  text: "ข้อมูลผู้ใช้งานนี้ถูกใช้ไปแล้ว",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.username = "";
              } else {
                this.$swal.fire(
                  "เกิดข้อผิดพลาด",
                  "โปรดติดต่อผู้ดูแลระบบ",
                  "error"
                );
              }
            })
            .catch((err) => {
              // console.log("api post err");
            });
        } else if (this.mode == "edit") {
          this.axios
            .put(
              process.env.VUE_APP_API + "api/v1/user/" + this.user_index,
              data,
              this.header_token
            )
            .then((response) => {
              // console.log(response.data);
              if (response.data == "update success") {
                this.$swal.fire({
                  icon: "success",
                  title: "แก้ไขข้อมูลข้อมูลผู้ใช้งานสำเร็จ",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.getUserList();
                this.closeUserDialog();
              } else if (response.data == "email already") {
                this.$swal.fire({
                  icon: "warning",
                  title: "ช้อมูลซ้ำ",
                  text: "อีเมลนี้ถูกใช้ไปแล้ว",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.email = "";
              } else if (response.data == "username already") {
                this.$swal.fire({
                  icon: "warning",
                  title: "ช้อมูลซ้ำ",
                  text: "ข้อมูลผู้ใช้งานนี้ถูกใช้ไปแล้ว",
                  showConfirmButton: false,
                  timer: 1000,
                });
                this.username = "";
              } else {
                this.$swal.fire(
                  "เกิดข้อผิดพลาด",
                  "โปรดติดต่อผู้ดูแลระบบ",
                  "error"
                );
              }
            })
            .catch((err) => {
              // console.log("api put err");
            });
        }
      } else {
        this.$swal.fire(
          "ข้อมูลไม่สมบูรณ์!",
          "กรุณากรอกข้อมูลใหม่อีกครั้ง",
          "warning"
        );
      }
    },
    deleteUser(item) {
      this.$swal
        .fire({
          title: "คุณต้องการลบข้อมูลข้อมูลผู้ใช้งานนี้ใช่หรือไม่?",
          text: "ข้อมูลจะถูกลบทันทีเมื่อกด 'ยืนยัน' ยกเลิกรายการกด 'ยกเลิก'",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#d33",
          // cancelButtonColor: "#3085d6",
          confirmButtonText: "ยืนยัน",
          cancelButtonText: "ยกเลิก",
        })
        .then((result) => {
          if (result.value) {
            this.axios
              .delete(
                process.env.VUE_APP_API + "api/v1/user/" + item.userId,
                this.header_token
              )
              .then((response) => {
                // console.log(response.data);
                if (response.data == "delete success") {
                  this.$swal.fire({
                    icon: "success",
                    title: "ลบข้อมูลผู้ใช้งานสำเร็จ",
                    showConfirmButton: false,
                    timer: 1000,
                  });
                  this.getUserList();
                }
              })
              .catch((err) => {
                // console.log("api delete err");
              });
          }
        });
    },
  },
};
</script>
<style scoped></style>
